/* istanbul ignore file */
export enum StepNames {
  SelectPositions = "Select positions",
  PaymentDetails = "Payment details",
  ReviewAndSubmit = "Review and submit",
  Complete = "Complete",
  Error = "Error",
}
